import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import ResourceVisibilityService from "../../src/Services/ResourceVisibility.service";
const ResourceVisibilityLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        labelKey: "description",
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<ResourceVisibility[]>' is not assignable to type '(ids: string[]) => Promise<ResourceVisibility[]>'.
        fetchItemsById: (ids) => {
            return ResourceVisibilityService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return ResourceVisibilityService.searchAll(search);
        },
        optionRenderer: function optionRenderer(resourceVisibility) {
            return _jsx("span", { children: resourceVisibility.description });
        },
    });
};
export default ResourceVisibilityLookup;
